import groq from "groq";

export const ButtonQuery = groq`
link{
  ...,
  url,
  "internalUrl": internalLink->slug.current,
  blank,
  _type,
  label,
  type,
  internalLink-> {
    _type,
  }
}`;
  